module.exports = __webpack_public_path__ + "static/assets/85143e859987be5833c754f95eba60a2.svg";